import React from "react";
import "./home_seis.scss";
import { useEffect, useState } from "react";
import { useAxios } from "../../../hooks/useAxios";
import Dot from "../../../assets/imgs/home_dos/dots.png";
import BookSwiper from "../../../components/BookSwiper/BookSwiper";
import { useTranslation } from "react-i18next";

const Home_seis = () => {
  const [t, i18n] = useTranslation("home");
  const [g] = useTranslation("global");
  const { data, isloading, error } = useAxios(
    `/library/nbooks2?offset=0&next=9&sitioid=2&lenguaje=${i18n.language}`
  );
  const liga_lang1 = "/" + i18n.language + "/biblioteca";
  const [books, setBooks] = useState(null);

  useEffect(() => {
    if (data) {
      setBooks(data);
    }
  }, [data]);

  return (
    <div className="home_seis">
      <div className="titulo">
        <h4>{t("library.from-my")}</h4>
        <div
          dangerouslySetInnerHTML={{ __html: t("library.search-you") }}
        ></div>
      </div>
      <div className="dot_4">
        <img src={Dot} alt="Imagen de puntos" />
      </div>

      <div className="carousel_prov Libreria biblio_cont">
        {isloading || books === null ? (
          <div>Is loading</div>
        ) : (
          <BookSwiper items={books} active={0} />
        )}
      </div>

      <div className="recomendaciones_btn">
        <a href={liga_lang1} className="btn_recom">
          {g("general.my-recommendations")}
        </a>
      </div>
      <div className="H6_dot_5">
        <img src={Dot} className="dot_img2" alt="Imagen de puntos" />
      </div>
    </div>
  );
};

export default Home_seis;
